































































































































































































































import { Component, Vue } from 'vue-property-decorator';
import papa from 'papaparse';
import dayjs from 'dayjs';
import excel from 'exceljs';
import InformationIcon from 'mdi-vue/InformationOutline';
import { AxiosError } from 'axios';
import { mapActions, mapState } from 'vuex';

import LayoutTitle from '@/components/LayoutTitle.vue';
import LayoutContent from '@/components/LayoutContent.vue';
import TagInput from '@/components/TagInput.vue';
import Loader from '@/components/Loader.vue';
import Button from '@/components/Button.vue';
import Table from '@/components/Table/Table.vue';
import TableBody from '@/components/Table/TableBody.vue';
import Header from '@/components/Table/Header.vue';
import Row from '@/components/Table/Row.vue';
import Cell from '@/components/Table/Cell.vue';
import ScrollbarWrapper from '@/components/ScrollbarWrapper.vue';
import SummaryBox from '@/components/SummaryBox.vue';
import Modal from '@/components/Modal.vue';
import { showToast } from '@/libs/toast';
import { ToastType } from '@/store/toast';
import format from '@/libs/numberFormat';
import api from '@/libs/api';
import type { Bank } from '@/libs/api.interfaces';
import { ActionTypes, State } from '@/store/disbursement';

@Component({
  components: {
    LayoutTitle,
    LayoutContent,
    TagInput,
    Loader,
    Button,
    Table,
    TableBody,
    Header,
    Row,
    Cell,
    ScrollbarWrapper,
    InformationIcon,
    SummaryBox,
    Modal,
  },
  computed: mapState(['disbursement']),
  methods: {
    format,
    ...mapActions({ getBalance: ActionTypes.GET_DISBURSEMENT_BALANCE }),
  },
})

export default class UploadData extends Vue {
  disbursement!: State;
  $refs!: {
    'file-input': HTMLInputElement;
  }

  getBalance!: () => void;
  format!: (value: string | number) => string;

  file: File | null = null;
  data: { value: string; status: boolean }[][] = [];
  rowData: boolean[] = [];
  destinationBank: string[] = [];
  isValid = true;
  processed = false;
  loading = false;
  bankList: Bank = {};

  showModal = false;

  openFileInput() {
    this.$refs['file-input'].click();
  }

  async onFileDrag(event: DragEventInit) {
    if (!event.dataTransfer) return;
    const [file] = event.dataTransfer.files;

    this.checkFile(file);
  }

  async onFileInput(event: Event) {
    const target = event.target as HTMLInputElement;
    const { files } = target;

    if (files === null || files.length === 0) return;
    const file = files[0];

    this.checkFile(file);
  }

  async checkFile(file: File) {
    if (file.type === 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet') {
      this.readExcel(file);
    } else if (file.type === 'text/csv' || file.type === 'application/vnd.ms-excel') {
      this.readCsv(file);
    } else {
      console.log(file);
      showToast(ToastType.FAILED, 'Invalid file', 'File Format must be Ms. Excel (XLSX) or CSV');
    }
  }

  async readExcel(file: File) {
    this.data = [];
    this.destinationBank = [];
    this.rowData = [];
    this.isValid = true;

    const workbook = new excel.Workbook();
    const buffer = await this.fileToBuffer(file);

    try {
      await workbook.xlsx.load(buffer);
      const sheet = workbook.worksheets[0];
      sheet.eachRow((row, rowNumber) => {
        if (rowNumber === 1) return;

        const cells: { value: string; status: boolean }[] = [];
        let status = true;

        for (let i = 1; i <= 12; i += 1) {
          const cellNumber = i;
          const cell = row.getCell(i);

          const currentStatus = this.validateCell(cellNumber, cell.text);
          if (status) status = currentStatus;
          if (!status) this.isValid = false;

          cells.push({ value: cell.text, status: currentStatus });
        }

        if (status && !this.destinationBank.includes(cells[5].value)) {
          this.destinationBank.push(cells[5].value);
        }

        this.data.push(cells);
        this.rowData.push(status);
      });

      this.processed = true;
    } catch (err) {
      console.log(err);
      showToast(ToastType.FAILED, 'Error', 'Error when reading the Excel file');
    }
  }

  async readCsv(file: File) {
    this.data = [];
    this.destinationBank = [];
    this.rowData = [];
    this.isValid = true;
    const referenceId = Math.random().toString(36).slice(2);

    papa.parse<string>(file, {
      skipEmptyLines: 'greedy',
      complete: (result) => {
        result.data.forEach((row, index) => {
          if (index === 0) return;

          const cells: { value: string; status: boolean }[] = [];
          let status = true;

          for (let i = 0; i < 10; i += 1) {
            const cellNumber = i;
            let cell = row[i];
            if (cellNumber === 8) {
              cell = parseFloat(cell.trim()).toString();
            }

            const currentStatus = this.validateCell(cellNumber + 1, cell);
            if (status) status = currentStatus;
            if (!status) this.isValid = false;

            cells.push({ value: cell, status: currentStatus });
          }
          cells.push({ value: `${referenceId}_${index - 1}`, status });

          this.data.push(cells);
          this.rowData.push(status);
        });

        this.processed = true;
      },
      error: (error) => {
        console.log(error);
        showToast(ToastType.FAILED, 'Error', 'Error when reading the CSV file');
      },
    });
  }

  // eslint-disable-next-line class-methods-use-this
  validateCell(col: number, value: string) {
    switch (col) {
      case 1:
        return dayjs(value).isValid();
      // case 2:
      //   return value !== '';
      case 3:
        return value !== '';
      case 4:
        return value !== '';
      case 5:
        return value !== '';
      case 6:
        return value !== '';
      case 7:
        return value !== '';
      case 8:
        return value !== '';
      case 9:
        return value !== '';
      case 10:
        return !Number.isNaN(parseFloat(value));
      case 11:
        return value !== '';
      case 12:
        return value === 'SUCCESS' || value === 'FAILED';
      default:
        return true;
    }
  }

  continueProcess() {
    this.showModal = true;
  }

  cancelProcess() {
    this.showModal = false;
  }

  async process() {
    this.loading = true;

    /* eslint-disable @typescript-eslint/camelcase */
    const flagData = this.data.map((e) => ({
      trx_id: e[3].value,
      flag_status: e[11].value,
      recipient_name: e[7].value,
    }));
    /* eslint-enable @typescript-eslint/camelcase */

    try {
      const data: any = await api.post('/disbursement/auto-flag', { data: flagData });
      showToast(ToastType.SUCCESS, 'Congratulations', data.data.info);
      this.loading = false;
      this.$router.push('/auto-disbursement-management/auto-flag/report');
    } catch (err) {
      console.log(err);
      this.loading = false;
      const error = err as AxiosError;

      if (error.response) {
        showToast(ToastType.FAILED, 'Oops… Sorry', error.response.data.error.message);
      } else {
        showToast(ToastType.FAILED, 'Error', 'Error when processing the disbursement');
      }
    }
  }

  cancel() {
    this.data = [];
    this.destinationBank = [];
    this.rowData = [];
    this.isValid = true;
    this.file = null;
    this.processed = false;
  }

  fileToBuffer = (file: File): Promise<ArrayBuffer> => new Promise(((resolve, reject) => {
    const reader = new FileReader();

    reader.onload = (event: ProgressEvent<FileReader>) => {
      if (event.target === null) {
        reject(new Error('Failed to read file'));
      } else {
        const buffer = event.target.result;
        resolve(buffer as ArrayBuffer);
      }
    };
    reader.readAsArrayBuffer(file);
  }))

  dateFormat = (time: string) => {
    const formatted = dayjs(time).format('MMMM D, YYYY HH:mm:ss');
    if (formatted === 'Invalid Date') {
      return 'Invalid Date';
    }

    return formatted;
  }

  // eslint-disable-next-line class-methods-use-this
  get time() {
    return dayjs().format('MMMM D, YYYY HH:mm:ss');
  }

  get banks() {
    return this.destinationBank.map((e) => this.bankList[e]).sort().join(', ');
  }
}
